module.exports = __webpack_public_path__ + "img/CM-BS-25-BMW-Lifestyle.414cc99d.jpg";